<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <md-card class="">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>calendar_view_month</md-icon>
        </div>
        <h4 class="title">
          {{ data.label }}
          <md-button
            @click.native="exportExcel()"
            v-if="data.data.length > 0"
            class="xls-export md-round md-success md-just-icon"
            :title="data.label + ' downloaden'"
          >
            <md-icon class="material-icons">file_download</md-icon>
          </md-button>
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-layout-data">
            <md-table class="">
              <md-table-row
                v-for="(row, rowIndex) in data.data"
                :key="rowIndex"
              >
                <md-table-cell
                  class="cursor-pointer"
                  @click.native="handleClick(row)"
                  >{{ getFullName(row) }}</md-table-cell
                >
                <md-table-cell>{{ row["value"] }}</md-table-cell>
              </md-table-row>
              <md-table-row v-if="data.data.length === 0">
                <md-table-cell
                  >Deze widget heeft geen data om weer te geven.</md-table-cell
                >
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["data"],
  methods: {
    getFullName(data) {
      return (
        data["first_name"] +
        " " +
        (data["last_name_prefix"] ? data["last_name_prefix"] + " " : "") +
        data["last_name"]
      );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    exportExcel() {
      let exportData = [];

      exportData.push(["Naam", "Datum"]);

      for (let i in this.data.data) {
        exportData.push([
          this.getFullName(this.data.data[i]),
          this.data.data[i]["value"]
        ]);
      }

      this.notifyVue(
        "Export " + this.data.label + " download gestart",
        "check",
        "success",
        5000
      );

      this.$http
        .post(
          this.$apiBaseUrl + "dashboard/export/xlsx",
          {
            label: this.data.label,
            data: exportData
          },
          {
            responseType: "blob"
          }
        )
        .then(
          response => {
            const filename = response.headers.map["content-disposition"][0]
              .split(";")[1]
              .split("filename")[1]
              .split("=")[1]
              .trim()
              .replaceAll('"', "");
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const fURL = document.createElement("a");

            fURL.href = fileURL;
            fURL.setAttribute("download", filename);
            document.body.appendChild(fURL);
            fURL.click();
            document.body.removeChild(fURL);
          },
          response => {
            this.notifyVue(
              "Fout geconstateerd tijdens exporteren van " +
                this.data.label +
                ":<br/>" +
                response.body,
              "report_problem",
              "danger",
              0
            );
          }
        );
    },
    handleClick(item) {
      this.$router.push("/drivers/edit/" + item.user_id);
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-layout-data {
  max-height: 200px;
  overflow-y: auto;
}

.xls-export {
  float: right;
  min-width: unset;
  margin-top: -13px;
}
</style>
